import ServeurRule from './ServeurRule'
import ValidationRules from './ValidationRules'
import toasted from '@/utils/toasted'
import _ from 'lodash'

export default {
  mixins: [ServeurRule, ValidationRules],
  data() {
    return {
      errors: {
        fields: {},
        globals: [],
      },
      resetErreur: this.__reset,
    }
  },

  provide() {
    return {
      errors: this.errors,
    }
  },

  methods: {
    // getForms() {
    //XXX methode à implémenter dans le composant utilisant le mixins
    // },

    __reset() {
      //reset des erreurs de validaion du serveurs
      this.errors.fields = {}
      this.errors.globals = []
    },

    __valider(reset = true) {
      if (reset) {
        //reset des erreurs de validaion du serveurs
        this.errors.fields = {}
        this.errors.globals = []
      }
      const ok = this.getForms()
        .map((f) => {
          f.validate()
        })
        .every((v) => {
          !!v
        })
      return ok
    },

    /**
     * Accepte les erreurs et mise à jour de la validation des erreurs
     */
    errorsHandler(errors) {
      //mise à jours des erreurs
      const fields = {}
      this.errors.fields = fields
      this.errors.globals = errors.globalErrors || {}

      if (errors.fieldErrors) {
        errors.fieldErrors.forEach((item) => {
          if (!fields[item.field]) {
            fields[item.field] = []
          }
          item.defaultMessage = this.$t(item.defaultMessage)
          fields[item.field].push(item)
        })
        //gestion de la validation des messages du back
        this.__valider(false)
      }

      if (this.errors.globals && !_.isEmpty(this.errors.globals)) {
        try {
          this.errors.globals.forEach((item) => {
            if (item.defaultMessage) {
              toasted.error(this.$t(item.defaultMessage))
            }
          })
        } catch (err) {
          console.log(err)
        }
      }
    },
  },
}
